import React from 'react';
import { NavLink } from 'react-router-dom'; 
import { Link } from 'react-router-dom';
import './Nav.css';
import logo from './imgs/logo.png';

const Navbar = () => {
  // Function to collapse the navbar on link click
  const handleNavLinkClick = () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.querySelector('#navbarNav');
    if (navbarCollapse.classList.contains('show')) {
      navbarToggler.click(); // Simulate a click to collapse the menu
    }
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top">
      
      <Link to="/" className="logo-link">
      <img className="logo" src={logo} alt="Logo" />
    </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <NavLink className="nav-link" to="/" end onClick={handleNavLinkClick}>Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/about" onClick={handleNavLinkClick}>About</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/projects" onClick={handleNavLinkClick}>Projects</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={handleNavLinkClick}>Contact</NavLink>
            </li>
          </ul>
        </div>
    </nav>
  );
};

export default Navbar;
